const isLoggedIn = () => (
    localStorage.getItem('auth')
)

export default isLoggedIn;